import {
  AdditionalFields,
  InspirationalTemplateAssetType as AssetType,
} from '../domain/entities/inspirationalTemplate';

export const INSPIRATIONAL_TEMPLATE_MAP: Record<string, AdditionalFields> = {
  // Design Wrap
  'b991864c-cd05-498d-85e2-03459fdeb6ec': {
    backgroundColor: '#F3FFE0',
    shortDescription:
      'Take inspiration from how this one-pager stops the scroll and subverts expectations.',
    features: [
      'Transparent video',
      'Hover animation',
      'Text marquee',
      'Custom code',
      'CSS grid',
      'Assets library for download',
    ],
    inspirationalAssets: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/design-wrap-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/design-wrap-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://img-wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/1920x1474_Design_Wrap.jpg',
        type: AssetType.IMAGE,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/design-wrap-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    inspirationalAssetsV2: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/design-wrap-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/design-wrap-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/1474_Desgin%20wrap_ABCDE_video.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/design-wrap-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    thumbnailUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/Vertical%20Thumb_Design%20Wrap.mp4',
  },
  // Cosmic Scroll
  'd674b741-2412-4260-af3f-c5f0e964fcd5': {
    backgroundColor: '#F4EDFF',
    shortDescription:
      'Fuel your imagination and get set for launch with this stellar space exploration site.',
    features: [
      'Scroll animation',
      'Loop animation',
      'Horizontal scroll',
      'Hover effects',
      'Custom CSS',
    ],
    inspirationalAssets: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/cosmic-scroll-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/cosmic-scroll-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://img-wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/1920x1474_Cosmic_Scroll.jpg',
        type: AssetType.IMAGE,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/cosmic-scroll-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    inspirationalAssetsV2: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/cosmic-scroll-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/cosmic-scroll-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/1474_Cosmic%20scroll%20_video.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/cosmic-scroll-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    thumbnailUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/VerticalThumb_Cosmic.mp4',
  },
  // Words Move
  '8de718ac-8cc4-4b69-88ab-4d92920c37a2': {
    backgroundColor: '#FFE8E4',
    shortDescription:
      'Make a statement and add movement with dynamic text marquees.',
    features: [
      'Text marquee',
      'Scroll animation',
      'Loop animation',
      'Entrance animation',
      'Background scroll effects',
      'CSS grid',
    ],
    inspirationalAssets: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/words-move/words-move-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/words-move-3-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/words-move-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/words-move-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    inspirationalAssetsV2: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/words-move/words-move-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/words-move-3-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/words-move-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/words-move-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    thumbnailUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/VerticalThumb_Words%20move.mp4',
  },
  // Animal Motion
  '50d5ca42-112a-466a-aca2-fd8bc927a965': {
    backgroundColor: '#E2FFE2',
    shortDescription:
      'Get inspired by scroll effects and animations that keep readers hooked on this nonprofit’s message.',
    features: [
      'Scroll animation',
      'Loop animation',
      'Entrance animation',
      'Transparent video',
      'CSS grid',
      'Stack',
    ],
    inspirationalAssets: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/animal-motion-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://img-wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/1920x1474_Animal_Motion.jpg',
        type: AssetType.IMAGE,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/animal-motion-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/animal-motion-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    inspirationalAssetsV2: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/animal-motion-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/1474_Animal%20Motion_bag_video.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/animal-motion-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/animal-motion-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    thumbnailUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/VerticalThumb_Animal_Motion_New.mp4',
  },
  // Athletic Spirit
  '31ec1ed2-9432-46e2-8175-5e4ccab9b5b9': {
    backgroundColor: '#FFE6F1',
    features: [
      'Scroll animation',
      'Loop animation',
      'Entrance animation',
      'Text marquee',
      'Background gradient',
      'Background scroll effects',
    ],
    shortDescription:
      'Breathe life into facts, stats and figures with scrollytelling.',
    inspirationalAssets: [
      {
        url: 'https://img-wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/1920x1080_Athletic_Spirit.jpg',
        type: AssetType.IMAGE,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/athletic-spirit-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://img-wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/1920x1474_Athletic_Spirit.jpg',
        type: AssetType.IMAGE,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/athletic-spirit-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    inspirationalAssetsV2: [
      {
        url: 'https://img-wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/1920x1080_Athletic_Spirit.jpg',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/athletic-spirit-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/1474_astletic%20Spirit%20(1).mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/athletic-spirit-2-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
    ],
    thumbnailUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/VerticalThumb_Athletic%20Spirit.mp4',
  },
  // Starcast Project
  '498fe8fb-46ba-45a5-9346-3bb5b1c9f61c': {
    backgroundColor: '#E6F2FF',
    features: [
      'Mouse effects',
      'Sticky position',
      'Horizontal scroll',
      'Scroll animation',
      'Custom code',
    ],
    shortDescription:
      'Unveil the mysteries of the zodiac and let this astrology site be the muse for your next project.',
    inspirationalAssets: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/starcast-project-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://img-wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/1920x1474_Starcast_Project_1.jpg',
        type: AssetType.IMAGE,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/starcast-project-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://img-wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/1920x1474_Starcast_Project_2.jpg',
        type: AssetType.IMAGE,
      },
    ],
    inspirationalAssetsV2: [
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/starcast-project-1920-1080.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/1474_Starcast%20Project_cancer_video.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/starcast-project-1920-1474.mp4',
        type: AssetType.VIDEO,
      },
      {
        url: 'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/video/1474_Starcast%20Project_video.mp4',
        type: AssetType.VIDEO,
      },
    ],
    thumbnailUrl:
      'https://wixmp-530a50041672c69d335ba4cf.wixmp.com/studio/inspirational-templates/thumbnails/VerticalThumb_Astrology.mp4',
  },
};
